import * as yup from "yup";
import i18n from "~/i18n";

export const NoteVersionFormValidator = yup.object().shape({
  name: yup.string().max(191, i18n.t("Max 191 characters")),
});
